import { useState } from "react";

import { Button, addToast } from "@icg360/design-system";

import { type PolicyPaymentDataQuery } from "gql/__generated__/hooks";
import { trackEvent } from "utils";

import EditMortgageeModal from "./edit-mortgagee-modal";

type EditMortgageeProps = {
  mortgagee: NonNullable<
    NonNullable<PolicyPaymentDataQuery["userBilling"]>["mortgagees"]
  >[number];
  policyId: string;
  keystonePolicyId: string;
};

const EditMortgagee = ({
  mortgagee,
  policyId,
  keystonePolicyId,
}: EditMortgageeProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const openModal = () => {
    setShowEditModal(true);
    trackEvent("Edit mortgagee modal displayed");
  };

  return (
    <>
      <Button
        appearance="tertiary"
        size="xs"
        onPress={openModal}
        data-testid="edit-mortgagee-btn"
      >
        Edit
      </Button>
      <EditMortgageeModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        mortgageeData={mortgagee ?? undefined}
        readablePolicyId={policyId}
        policyId={keystonePolicyId}
        onEditMortgageeSuccess={() => {
          setShowEditModal(false);
          addToast("The mortgagee information has been successfully updated.", {
            icon: true,
          });
        }}
      />
    </>
  );
};

export default EditMortgagee;
